import React from "react";
import CurrentStatusRight from "./CurrentStatusRight";
import CurrentStatusMiddle from "./CurrentStatusMiddle";

const CurrentStatus = ({ statusBreakup, loading, height, ...props }) => {
  let total = 0;

  const handleClickOpenJobCard = (e) => {
    e.preventDefault();
    props.history.push(`/job-card`);
  };

  const handleJobCardDownload = () => {
    props.jobCardDownload();
  };

  statusBreakup.map(st => total += st.jobs.length);
  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div style={{ width: '40%' }}>
        <CurrentStatusRight total={total} statusBreakup={statusBreakup} downloading={props.jobDataDownloadLoading}
          handleClickDownload={handleJobCardDownload} handleShow={handleClickOpenJobCard} />
      </div>
      <div style={{ width: '60%', height: height, overflowY: 'scroll', float: 'right' }}>
        <CurrentStatusMiddle statusBreakup={statusBreakup} total={100} loading={loading} />
      </div>
    </div>

  );
};

export default CurrentStatus;
